// @generated by protoc-gen-es v2.14.0 with parameter "target=ts,import_extension=none"
// @generated from file basic.proto (package puppy.proto.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_gnostic_openapi_v3_annotations } from "./gnostic/openapi/v3/annotations_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file basic.proto.
 */
export const file_basic: GenFile = /*@__PURE__*/
  fileDesc("CgtiYXNpYy5wcm90bxIOcHVwcHkucHJvdG8udjEiDgoMRW1wdHlSZXF1ZXN0Ig8KDUVtcHR5UmVzcG9uc2UqUQoIVXNlclR5cGUSGQoVVVNFUl9UWVBFX1VOU1BFQ0lGSUVEEAASEgoOVVNFUl9UWVBFX1VTRVIQARIWChJVU0VSX1RZUEVfU1VCX1VTRVIQAkIgukcdEhsKFVB1cHB5IFNlcnZlciBwcm90b2NvbDICdjFiBnByb3RvMw", [file_gnostic_openapi_v3_annotations]);

/**
 * 空请求消息（占位用）。
 * 
 * 说明：当某些 RPC 需要显式的请求类型但没有任何字段时使用。
 *
 * @generated from message puppy.proto.v1.EmptyRequest
 */
export type EmptyRequest = Message<"puppy.proto.v1.EmptyRequest"> & {
};

/**
 * Describes the message puppy.proto.v1.EmptyRequest.
 * Use `create(EmptyRequestSchema)` to create a new message.
 */
export const EmptyRequestSchema: GenMessage<EmptyRequest> = /*@__PURE__*/
  messageDesc(file_basic, 0);

/**
 * 空响应消息（占位用）。
 * 
 * 说明：当某些 RPC 没有业务返回值时使用。
 *
 * @generated from message puppy.proto.v1.EmptyResponse
 */
export type EmptyResponse = Message<"puppy.proto.v1.EmptyResponse"> & {
};

/**
 * Describes the message puppy.proto.v1.EmptyResponse.
 * Use `create(EmptyResponseSchema)` to create a new message.
 */
export const EmptyResponseSchema: GenMessage<EmptyResponse> = /*@__PURE__*/
  messageDesc(file_basic, 1);

/**
 * 用户类型枚举
 *
 * @generated from enum puppy.proto.v1.UserType
 */
export enum UserType {
  /**
   * 未指定
   *
   * @generated from enum value: USER_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 主用户
   *
   * @generated from enum value: USER_TYPE_USER = 1;
   */
  USER = 1,

  /**
   * 子用户
   *
   * @generated from enum value: USER_TYPE_SUB_USER = 2;
   */
  SUB_USER = 2,
}

/**
 * Describes the enum puppy.proto.v1.UserType.
 */
export const UserTypeSchema: GenEnum<UserType> = /*@__PURE__*/
  enumDesc(file_basic, 0);

